module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1018.0355ecc4.png";